export default __webpack_public_path__ + "img/do-Logo-660x330.31b24ebd.png";